/**
 * Dados de contato padrão da empresa.
 * O número de WhatsApp pode ser sobrescrito pela configuração da tabela de
 * preços no painel (pricing/config/whatsappNumber).
 */
export const WHATSAPP_NUMBER = "5548996275321";
export const CONTACT_EMAIL = "Markinhos_sousa2009@hotmail.com";
export const CONTACT_PHONE_DISPLAY = "+55 48 99627-5321";
export const SITE_URL = "https://www.mbfloripaturismo.com.br";

export const whatsappUrl = (number: string = WHATSAPP_NUMBER, text?: string) => {
  const digits = number.replace(/\D/g, "");
  const base = `https://wa.me/${digits}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
};
